import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '../lib/api';

export const useWishlistStore = create(
  persist(
    (set, get) => ({
      bookIds: [],
      toggle: (bookId) => {
        const { bookIds } = get();
        const newBookIds = bookIds.includes(bookId)
          ? bookIds.filter((id) => id !== bookId)
          : [...bookIds, bookId];

        set({ bookIds: newBookIds });

        // Sync with server; revert local state if it fails.
        api.post(`/wishlist/${bookId}`).catch(() => set({ bookIds }));
      },
      has: (bookId) => get().bookIds.includes(bookId),
      // Function to initialize from server data
      initFromServer: (bookIds) => {
        console.log('Initializing wishlist store from server with book IDs:', bookIds); // Debug log
        set({ bookIds });
      },
      // Function to fetch and sync with server
      syncWithServer: async () => {
        try {
          const data = await api.get('/wishlist');
          const bookIds = (data.wishlist || data.books || []).map(book => book._id || book.id);
          console.log('Syncing wishlist store with server. Book IDs:', bookIds); // Debug log
          set({ bookIds });
          return data.wishlist || data.books || [];
        } catch (err) {
          console.error('Failed to sync wishlist with server:', err);
          throw err;
        }
      }
    }),
    { name: 'geniusmind-wishlist' }
  )
);
